<template>
    <div class="our_memories re_sizing" ref="scrollContainer">
        <div class="title re_relative re_flex_center re_font_18" :class="{ 'is-pad-top': userStore.isPadTop }">
            <van-icon @click="goBack()" class="icon" name="arrow-left" size="22" />
            <span>我们的回忆</span>
        </div>
        <div class="profile">
            <div class="avatar">
                <div class="img">
                    <img :src="memory.userPhoto" alt="">
                    <div v-if="memory.userNickName && memory.userNickName.length < 6" class="name name_right">{{memory.userNickName || ''}}</div>
                    <div v-if="memory.userNickName && memory.userNickName.length >= 6" class="name name_right">{{ memory.userNickName.slice(0, 5) || '' }}...</div>
                </div>
                
            </div>
            <div class="action">{{memory.relation || ''}}</div>
            <div class="avatar">
                <div class="img">
                    <img :src="memory.pairUserPhoto" alt="">
                    <div v-if="memory.pairUserNickName && memory.pairUserNickName.length < 6" class="name name_left">{{memory.pairUserNickName || ''}}</div>
                    <div v-if="memory.pairUserNickName && memory.pairUserNickName.length >= 6" class="name name_left">{{ memory.pairUserNickName.slice(0, 5) || '' }}...</div>
                </div>
            </div>
        </div>
        <div class="introduce" v-if="memory.ourMemoryDescribeVo">
            <div>{{memory.ourMemoryDescribeVo.title || ''}}</div>
            <div>{{memory.ourMemoryDescribeVo.pairContent || ''}}</div>
            <div>{{memory.ourMemoryDescribeVo.pairChatContent || ""}}</div>
        </div>
        <div class="content">
            <div class="content_text" :style="{marginBottom: list.length > 3 ? '16px' : '24px'}">
                <div v-for="(item, index) in list" :key="index" class="content_item">
                    <div class="dot"></div>
                    <div v-if="index != (list.length - 1) ||  list.length == 1" :style="{height: index == (list.length - 1) ? 'calc(100% - 12px)' : '100%'}" class="line"></div>
                    <div class="itemContent" :class="{ 'right': index % 2 !== 0, 'left': index % 2 === 0}">
                        <div class="time">{{ item.date }}</div>
                        <div class="text">{{ item.content }}</div>
                    </div>
                </div>
            </div>
            <div class="content_footer">未来，期待我们拥有更多回忆</div>
        </div>
        <div style="height: 78px;width: 100%;"></div>
        <div class="footer">
            <div class="btn" @click="goGift">送Ta礼物</div>
            <div class="btn" @click="invitationTeam">邀Ta组局</div>
        </div>
    </div>
</template>
<script>

import { useUserStore } from '../../stores/user';
import {ref, onMounted, onBeforeMount} from 'vue'
import { useRoute } from 'vue-router'
import { outMemory } from './api'

export default {
    name: 'OurMemories',
    setup() {
        const route = useRoute()
        const userStore = useUserStore();
        const goBack = () => {
            let u = navigator.userAgent;
            let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

            if (isAndroid) {
                try {
                    appJsImp.finish()
                } catch (error) {
                    android.finish()
                }
            }
            if (isiOS) {
                window.webkit.messageHandlers.AppModel.postMessage('finish')
            }
        }
        // 送ta礼物
        const goGift = () => {
            let u = navigator.userAgent;
            let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

            if (isAndroid) {
                try {
                    appJsImp.givingGifts()
                } catch (error) {
                    android.givingGifts()
                }
            }
            if (isiOS) {
                window.webkit.messageHandlers.AppModel.postMessage('givingGifts')
            }
        }
        // 邀ta组局
        const invitationTeam = () => {
            let u = navigator.userAgent;
            let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端

            if (isAndroid) {
                try {
                    appJsImp.invitationTeam()
                } catch (error) {
                    android.invitationTeam()
                }
            }
            if (isiOS) {
                window.webkit.messageHandlers.AppModel.postMessage('invitationTeam')
            }
        }
        const list = ref([]);
        const memory = ref({})
        const ourMemoryDescribeVo = ref({})
        const getMemory = async (pairUserId) => {
            outMemory({pairUserId:pairUserId}).then(res => {
                if (res.code == 1) {
                    memory.value = res.data
                    ourMemoryDescribeVo.value = res.data.ourMemoryDescribeVo
                    list.value = res.data.ourMemoryInteractVoList
                }
            })
        }
        onBeforeMount(() => {
            document.querySelector('body').setAttribute('style', 'background:#FB508A;')
        })
        onMounted(() => {
            let u = navigator.userAgent;
            let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
            if(isiOS){
                userStore.isPadTop = true;
            }
            getMemory(route.query.pairUserId)
        })
        return {
            userStore,list,ourMemoryDescribeVo,memory,
            goBack, goGift, invitationTeam
        }
    }
}

</script>
<style lang="less" scoped>
body {
    background: #FB508A;
}
.our_memories {
    background: url(../../../assets/memories/bg.webp) left top no-repeat;
    background-size: 100% 100%;
    min-height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    .title {
        padding: 30px 0 18px 0;
        width: 100%;
        font-weight: 600;
        .icon {
            position: absolute;
            left: 16px;
            bottom: 18px;
        }
    }
    .is-pad-top {
        padding-top: 46px;
    }
    .profile {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0 16px;
        .avatar {
            width: 40%;
            display: flex;
            flex-flow: column;
            .img {
                width: 64px;
                height: 80px;
                text-align: center;
                img{
                    width: 60px;
                    height: 60px;
                    border-radius: 50%;
                    border: 2px solid #FFFFFF;
                    background: #FFFFFF;
                }
            }
            .name {
                margin-top: 4px;
                font-weight: 700;
                font-size: 14px;
                color: #540200;
                // overflow: hidden;
                // text-overflow: ellipsis;
                white-space: nowrap;
                text-align: center;
                width: 100%;
            }
        }
        .avatar:nth-child(1) {
            align-items: end;
            align-items: flex-end;
        }
        .avatar:nth-child(2) {
            align-items: baseline;
        }
        .action {
            background: url(../../../assets/memories/heart.webp) no-repeat;
            background-size: 100% 100%;
            width: 53px;
            height: 53px;
            display: flex;
            justify-content: center;
            line-height: 45px;
            font-weight: 700;
            font-size: 12px;
            color: #FF0E81;
            margin: 0 8px;
        }
        .avatar {
            
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
    .introduce {
        margin-top: 21px;
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 22px;
        text-align: center;
    }
    .content {
        background: url(../../../assets/memories/bg2.webp) no-repeat;
        background-size: 100% 100%;
        width: 327px;
        height: 378px;
        margin: 0 auto;
        padding: 110px 16px 0;
        .content_text {
            width: 100%;
            max-height: 85%;
            // background-color: #fff;
            overflow: auto;
            margin-bottom: 24px;
            .content_item {
                position: relative;
                .itemContent {
                    width: 126px;
                    padding: 10px;
                    background: #FBF4F2;
                    border: 1px solid #FFFFFF;
                    border-radius: 8px;
                    &.right {
                        margin: 0 0 0 auto;
                    }
                    &.left {
                        margin: 0 auto 0 0;
                    }
                    .time {
                        font-size: 12px;
                        color: #877B80;
                    }
                    .text {
                        margin-top: 8px;
                        font-weight: 400;
                        font-size: 14px;
                        color: #301332;
                    }
                }
                .dot{
                    position: absolute;
                    z-index: 2;
                    width: 4px;
                    height: 4px;
                    border: 2px solid #FF0E81;
                    background: #fff;
                    border-radius: 50%;
                    left: 50%;
                    top: 10px;
                    transform: translateX(-50%);
                }
                .line{
                    height: 100%;
                    position: absolute;
                    width: 4px;
                    background: #FFCBE0;
                    left: 50%;
                    top: 10px;
                    transform: translateX(-50%);
                    z-index: 1;
                }
            }
            
        }
        .content_footer {
            font-weight: 400;
            font-size: 14px;
            color: #540200;
            // margin-top: 16px;
            text-align: center;
        }
    }

    .footer {
        position: fixed;
        bottom: 0;
        left: 0;
        width: calc(100% - 32px);
        height: 70px;
        background: #ffffff82;
        z-index: 10;
        display: flex;
        justify-content: space-around;
        padding: 8px 16px 0;
        .btn {
            width: 48%;
            height: 48px;
            border-radius: 24px;
            background-image: linear-gradient(180deg, #FF8BBA 1%, #FF4E91 100%);
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            color: #FFFFFF;
            font-weight: 600;
        }
        .btn:nth-child(2) {
            background-image: linear-gradient(0deg, #9184FE 0%, #7C94FE 100%);
        }
    }
}
</style>